import { wsClient, WsRecvType, IWsHandler } from '../client'
import { IClientUID } from '../../api/clients'

export enum OtaWriteErrorCode {
    Ok = 0,
    AlreadyActive = 1,
    BeginFailed = 2,
    WriteFailed = 3,
    NewVersionSameAsInvalidVersion = 4,
    CurrentRunningVersionSameAsNew = 5,
    ReceivedPackageNotFitLen = 6,
}

type IMachineOtaWriteErrorData = {
    clientId: IClientUID
    errorCode: OtaWriteErrorCode
}

type IMachineOtaWriteErrorHandler = IWsHandler<IMachineOtaWriteErrorData>

type IMachineOtaWriteErrorCallback = (clientId: IClientUID, errorCode: OtaWriteErrorCode) => void

export type IListenerUID = number

const listeners_: Array<{ id: IListenerUID; callback: IMachineOtaWriteErrorCallback }> = []
let listenerInc_ = 0

export function MachineOtaWriteErrorHandler() {
    wsClient.submitHandler(WsRecvType.MachineOtaWriteError, (({ data }) => {
        console.log(`%c[WsClient][${new Date().toISOString()}] MachineOtaWriteError`, 'color: orange', data!.errorCode, data!.clientId)
        for (const listener of listeners_) {
            listener.callback(data!.clientId, data!.errorCode)
        }
    }) as IMachineOtaWriteErrorHandler)
}

export function onOtaWriteError(callback: IMachineOtaWriteErrorCallback): IListenerUID {
    listenerInc_++
    listeners_.push({ id: listenerInc_, callback })
    return listenerInc_
}

export function clearOtaWriteError(id: IListenerUID) {
    const index = listeners_.findIndex(listener => listener.id === id)
    if (index !== -1) {
        listeners_.splice(index, 1)
    }
}
